export default __webpack_public_path__ + "static/media/coin-img.76eb1167.webp";